// FILE PATH: eRFQFrontend/src/component/Vendor/LogisticDashboard/VendorLogisticsDashboard.jsx

import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import ItemCount from "../../../utils/ItemCount";
import LogisticsRfqs from "./LogisticsRfqs";

const VendorLogisticsDashboard = () => {

  const [rfq, setRfq] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(
    localStorage.getItem("logisticsActiveTab") || "INBIDDING"
  );

  const [vendor, setVendor] = useState();

  const storedUser = JSON.parse(localStorage.getItem("user"));

  const [buyerCount, setBuyerCount] = useState(0);
  const [invitedCount, setInvitedCount] = useState(0);
  const [inCount, setInCount] = useState(0);
  const [postCount, setPostCount] = useState(0);

  const fetchCounts = async (v) => {

    const target = v || vendor;
    if (!target) return;

    const fetchCount = async (tabStatus, setter) => {

      try {

        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/count?vendorId=${target.vendorId}&status=${tabStatus}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );

        setter(res.data);

      } catch (error) {
        console.log(error);
      }
    };

    fetchCount("INBIDDING", setInCount);
    fetchCount("POSTBIDDING", setPostCount);
    fetchCount("BUYERS", setBuyerCount);
    fetchCount("INVITED", setInvitedCount);
  };

  useEffect(() => {
    if (!vendor) return;
    fetchCounts(vendor);
    localStorage.removeItem("logisticsActiveTab");
  }, [vendor]);

  useEffect(() => {

    const getVendor = async () => {

      try {

        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor?email=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );

        localStorage.setItem("vendor", JSON.stringify(res.data.vendorId));
        setVendor(res.data);

      } catch (error) {
        console.log(error);
      }
    };

    getVendor();

  }, []);

  const getRFQs = async () => {

    if (!vendor) return;

    setIsLoading(true);

    try {

      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/logistic?vendorId=${vendor.vendorId}&status=${status}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );

      setRfq(res.data);

    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRFQs();
  }, [vendor, status]);

  return (
    <div>
      <Typography variant="h5">My Logistics RFQ</Typography>
      <Box className="dashboard-container">
        <Box
          sx={{
            display: "flex",
            gap: 1,
            pt: 2,
            borderBottom: "1px solid #dedede",
          }}
        >
          <Button
            className={`dashboard-btns ${
              status === "INBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("INBIDDING");
              localStorage.setItem("logisticsActiveTab", "INBIDDING");
            }}
          >
            In RFQ <ItemCount count={inCount} />
          </Button>
          <Button
            className={`dashboard-btns ${
              status === "POSTBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("POSTBIDDING");
              localStorage.setItem("logisticsActiveTab", "POSTBIDDING");
            }}
          >
            Post RFQ <ItemCount count={postCount} />
          </Button>
          <Button
            className={`dashboard-btns ${status === "BUYERS" ? "active" : ""}`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("BUYERS");
              localStorage.setItem("logisticsActiveTab", "BUYERS");
            }}
          >
            RFQ Invites <ItemCount count={buyerCount} />
          </Button>
          <Button
            className={`dashboard-btns ${status === "INVITED" ? "active" : ""}`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("INVITED");
              localStorage.setItem("logisticsActiveTab", "INVITED");
            }}
          >
            Invitations <ItemCount count={invitedCount} />
          </Button>
        </Box>
        <LogisticsRfqs
          rfq={rfq}
          isLoading={isLoading}
          activeTab={status}
          getRFQs={getRFQs}
          fetchCounts={() => fetchCounts(vendor)}
        />
      </Box>
    </div>
  );
};

export default VendorLogisticsDashboard;
